export enum Locale {
  SV = 'sv',
  EN = 'en',
  PL = 'pl',
  ET = 'et',
  FI = 'fi'
}

export type DomainLocale = Locale.SV | Locale.EN;
